const navigation = [
  {
    to: 'services',
    label: 'Servicios de hostelería',
  },
  {
    to: 'vinos',
    label: 'Nuestros vinos',
    url: true,
  },
  {
    to: 'subscription',
    label: 'El club del vino',
  },
  {
    to: 'contact',
    label: 'Contacto',
  },
]

export default navigation
